/* GFS Google Ads click ids. 2026-11-04.
   Stores gclid / gbraid / wbraid from the landing URL into first-party cookies
   and cart attributes. Remove this asset and the theme.liquid script line to undo. */
(function () {
  var MAX = 60 * 60 * 24 * 90;
  var KEYS = ['gclid', 'gbraid', 'wbraid'];

  function fromUrl(name) {
    var s = window.location.search;
    if (!s || s.length < 2) return '';
    var parts = s.substring(1).split('&');
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split('=');
      var k = kv[0];
      try { k = decodeURIComponent(k); } catch (e) {}
      if (k !== name) continue;
      var v = kv.slice(1).join('=');
      try { return decodeURIComponent(v.replace(/\+/g, ' ')); } catch (e2) { return ''; }
    }
    return '';
  }

  function cookieGet(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length < 2) return '';
    var raw = parts.pop().split(';').shift() || '';
    try { return decodeURIComponent(raw); } catch (e) { return raw; }
  }

  function cookieSet(name, value) {
    var secure = location.protocol === 'https:' ? ';Secure' : '';
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;max-age=' + MAX + ';SameSite=Lax' + secure;
  }

  var now = Math.floor(Date.now() / 1000);
  var fresh = {};
  var stored = {};
  for (var i = 0; i < KEYS.length; i++) {
    var key = KEYS[i];
    var urlVal = fromUrl(key);
    if (urlVal) fresh[key] = urlVal;
    var prev = cookieGet('gfs_' + key);
    if (prev) stored[key] = prev;
  }

  if (fresh.gclid) cookieSet('_gcl_aw', 'GCL.' + now + '.' + fresh.gclid);
  if (fresh.gbraid) cookieSet('_gcl_gb', 'GCL.' + now + '.' + fresh.gbraid);
  for (var j = 0; j < KEYS.length; j++) {
    if (fresh[KEYS[j]]) cookieSet('gfs_' + KEYS[j], fresh[KEYS[j]]);
  }

  var use = {
    gclid: fresh.gclid || stored.gclid || '',
    gbraid: fresh.gbraid || stored.gbraid || '',
    wbraid: fresh.wbraid || stored.wbraid || ''
  };
  if (!use.gclid && !use.gbraid && !use.wbraid) return;

  var sig = use.gclid + '|' + use.gbraid + '|' + use.wbraid;
  try {
    if (window.sessionStorage && sessionStorage.getItem('gfs_gclid_sig') === sig) return;
  } catch (e) {}

  var attrs = {};
  if (use.gclid) attrs.gclid = use.gclid;
  if (use.gbraid) attrs.gbraid = use.gbraid;
  if (use.wbraid) attrs.wbraid = use.wbraid;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'same-origin',
    keepalive: true,
    body: JSON.stringify({ attributes: attrs })
  }).then(function (res) {
    if (!res || !res.ok) return;
    try { sessionStorage.setItem('gfs_gclid_sig', sig); } catch (e2) {}
  }).catch(function () {});
})();